import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import * as func from "../../common/athleteCommon/FunctionCalls";
import * as api from "../../common/athleteCommon/API";
import Select from "react-select";
import HrvGraph from "./HRVgraph";
import RhrGraph from "./RHRgraph";
import SqtGraph from "./SQTgraph";
import FatigueGraph from "./FatigueGraph";
import MuscleSorenessGraph from "./MuscleSoreness";
import SleepQualityGraph from "./SleepQuality";
import JointStiffnessGraph from "./JointStiffnessGraph";
import MentalReadinessGraph from "./MentalReadiness";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Utils from "../../common/athleteCommon/Utils";
import UrineQualityGraph from "./UrineQualityGraph";
import RHRGraph from "./RHRGraph";
import HungerGraph from "./HungerGraph";

const AthleteMetrics = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [metricsData, setMetricsData] = useState<any[]>([]);
    const [metricScale, setMetricScale] = useState<any[]>([]);
    const [allMetricsData, setAllMetricsData] = useState<any[]>([]);
    const [date, setDate] = useState("");
    const [sleepQuality, setSleepQuality] = useState("");
    const [muscleSoreness, setMuscleSoreness] = useState("");
    const [fatigueLvl, setFatigueLvl] = useState("");
    const [jointStiffness, setJointStiffness] = useState("");
    const [mentalReadiness, setMentalReadiness] = useState("");
    const [urineQuality, setUrineQuality] = useState("");
    const [restingHeartRate, setRestingHeartRate] = useState("");
    const [hunger, setHunger] = useState("");
    const [period, setPeriod] = useState("last month");
    const [showRecentValues, setShowRecentValues] = useState(false);
    const [showMetrics, setShowMetrics] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const periodList = [{ prdVal: "last month", prdName: "Last Month" }, { prdVal: "last 3 months", prdName: "Last 3 Months" }, { prdVal: "last 6 months", prdName: "Last 6 Months" }, { prdVal: "most recent metrics", prdName: "Most Recent Metrics" }]


    const formRef = useRef(null);

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchMetrics() {
            setIsLoading(true);
            const metricResponse = await func.getMertricsData(period);
            setAllMetricsData(metricResponse || []);
            setMetricsData(metricResponse.recentData || [])
            setShowMetrics(true)
            setShowRecentValues(true)
            setIsLoading(false);
        }
        fetchMetrics();
    }, [])

    // Helper for date → DD-MM-YYYY
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    async function newMetrics() {
        setIsEdit(false);
        setOpenModal(true);
        const metricScaleResponse = await func.getMertricScale();
        setMetricScale(metricScaleResponse || []);
    }

    function changeValues(ischecked) {
        if (ischecked) {
            setMetricsData(allMetricsData.weeklyAvg)
            setShowRecentValues(true);
        } else {
            setMetricsData(allMetricsData.recentData)
            setShowRecentValues(true);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("date", date);
            formData.append("sleepQuality", sleepQuality);
            formData.append("muscleSoreness", muscleSoreness);
            formData.append("fatigueLevel", fatigueLvl);
            formData.append("jointStiffness", jointStiffness);
            formData.append("mentalReadiness", mentalReadiness);
            formData.append("urineQuality", urineQuality);
            formData.append("restingHeartRate", restingHeartRate);
            formData.append("hunger", hunger);

            const addChkin = api.CreateMetrics;
            fetch(addChkin, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((scdlResponse) => scdlResponse.json())
                .then((result) => {
                    setIsLoading(false);
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log("Failed to create new Schedule", error)
                })
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>{localStorage.getItem('FullName')} - Athlete Metrics</h4>
                                    <Link
                                        to="#"
                                        className="btn"
                                        onClick={() => { newMetrics() }}
                                        data-bs-toggle="tooltip"
                                        style={{ fontSize: "24px", padding: "0px" }}
                                        title="Create New Metrics">
                                        <i className="feather-plus" />&nbsp;
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Period</label>
                                    <Select
                                        value={periodList.find(prd => prd.prdVal === period) ? {
                                            value: period,
                                            label: periodList.find(prd => prd.prdVal === period).prdName
                                        } : null}
                                        onChange={async (e) => {
                                            setPeriod(e.value);
                                            const metricResponse = await func.getMertricsData(e.value);
                                            setAllMetricsData(metricResponse || []);
                                            setMetricsData(metricResponse.recentData || [])
                                            setShowMetrics(true)
                                            setShowRecentValues(true)
                                        }}
                                        required
                                        placeholder="Select Period"
                                        options={periodList.map(prd => ({
                                            value: prd.prdVal,
                                            label: prd.prdName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            {showMetrics && (
                                <>
                                    <div className="row mb-10 justify-space-between">
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Fatigue</h6>
                                                <FatigueGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Joint Stiffness</h6>
                                                <JointStiffnessGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Mental Readiness</h6>
                                                <MentalReadinessGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Muscle Soreness</h6>
                                                <MuscleSorenessGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Sleep Quality</h6>
                                                <SleepQualityGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Urine Quality</h6>
                                                <UrineQualityGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Resting Heart Rate</h6>
                                                <RHRGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 mb-10">
                                            <div className="p-3 h-100" style={{ border: "0.5px solid #E7E8E9" }}>
                                                <h6 className="text-center">Hunger Level</h6>
                                                <HungerGraph allData={allMetricsData} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="statistics-grid row align-items-center" style={{ padding: "10px" }}>
                                        <div className="col d-flex justify-content-between align-items-center">
                                            <h4 style={{ visibility: isChecked ? "hidden" : "visible" }}>
                                                Latest Metrics: {(metricsData != 0) ? formatDate(metricsData.date) : "No Data Available"}
                                            </h4>
                                            <div className="form-check form-switch d-flex align-items-end justify-content-end">
                                                <label>Want to know weekly average?</label>
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    id="togle"
                                                    onChange={(e) => {
                                                        changeValues(e.target.checked)
                                                        setIsChecked(e.target.checked)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {showRecentValues && (
                                        <>
                                            <div className="row">
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Fatigue Level</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.fatigueLevelName : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Joint Stiffness</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.jointStiffnessName : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Mental Readiness</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.mentalReadinessName : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Muscle Soreness</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.muscleSorenessName : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Sleep Quality</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.sleepQualityName : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Urine Quality</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.urineQualityName : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Resting Heart Rate</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.restingHeartRate : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2">
                                                    <div className="statistics-grid justify-content-center">
                                                        <div className="listing-content text-center">
                                                            <div className="listing title">
                                                                <h3>Hunger Level</h3>
                                                                <p className="text-center">{(metricsData != 0) ? metricsData.hungerLevelName : "No Data Available"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="xl"
                    scrollable
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Metrics</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => { setOpenModal(false);  }}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            placeholder="Enter Center Name"
                                            required
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="sortbytitle">Sleep Quality</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === sleepQuality) ? {
                                            value: sleepQuality,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === sleepQuality).sleepQuality
                                        } : null}
                                        onChange={(e) => {
                                            setSleepQuality(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.sleepQuality
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="sortbytitle">Muscle Soreness</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === muscleSoreness) ? {
                                            value: muscleSoreness,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === muscleSoreness).muscleSoreness
                                        } : null}
                                        onChange={(e) => {
                                            setMuscleSoreness(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.muscleSoreness
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="sortbytitle">Fatigue Level</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === fatigueLvl) ? {
                                            value: fatigueLvl,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === fatigueLvl).fatigueLevel
                                        } : null}
                                        onChange={(e) => {
                                            setFatigueLvl(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.fatigueLevel
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="sortbytitle">Joint Stiffness</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === jointStiffness) ? {
                                            value: jointStiffness,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === jointStiffness).jointStiffness
                                        } : null}
                                        onChange={(e) => {
                                            setJointStiffness(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.jointStiffness
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="sortbytitle">Mental Readiness</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === mentalReadiness) ? {
                                            value: mentalReadiness,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === mentalReadiness).mentalReadiness
                                        } : null}
                                        onChange={(e) => {
                                            setMentalReadiness(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.mentalReadiness
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="form-label">Urine Quality</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === urineQuality) ? {
                                            value: urineQuality,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === urineQuality).urineQuality
                                        } : null}
                                        onChange={(e) => {
                                            setUrineQuality(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.urineQuality
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="form-label">Resting Heart Rate</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === restingHeartRate) ? {
                                            value: restingHeartRate,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === restingHeartRate).restingHeartRate
                                        } : null}
                                        onChange={(e) => {
                                            setRestingHeartRate(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.restingHeartRate
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <label className="form-label">Hunger</label>
                                    <Select
                                        value={metricScale.find(mtrc => mtrc.athleteMetricScaleId === hunger) ? {
                                            value: hunger,
                                            label: metricScale.find(mtrc => mtrc.athleteMetricScaleId === hunger).hunger
                                        } : null}
                                        onChange={(e) => {
                                            setHunger(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={metricScale.map(mtrc => ({
                                            value: mtrc.athleteMetricScaleId,
                                            label: mtrc.hunger
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    );
};

export default AthleteMetrics;